import React, { useEffect, useState, useRef } from 'react';
import './ScrollDiv.css';
import useMediaQuery from '../hooks/useMediaQuery';

const ScrollDiv = ({children, style}) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [totalWidth, setTotalWidth] = useState(0);
  const [visibleWidth, setVisibleWidth] = useState(0);
  const [activeDot, setActiveDot] = useState(0);
  const scrollContainerRef = useRef(null);
  const isDesktop = useMediaQuery("(min-width: 1070px)");
  


  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      const updateScrollInfo = () => {
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
        setTotalWidth(scrollWidth);
        setVisibleWidth(clientWidth);
        
        // Calculate active dot based on scroll position
        const totalSections = Math.ceil(scrollWidth / clientWidth);
        const currentSection = Math.floor((scrollLeft + (clientWidth / 2)) / clientWidth);
        setActiveDot(Math.min(currentSection, totalSections - 1));
      };

      updateScrollInfo();
      container.addEventListener('scroll', updateScrollInfo);
      window.addEventListener('resize', updateScrollInfo);

      return () => {
        container.removeEventListener('scroll', updateScrollInfo);
        window.removeEventListener('resize', updateScrollInfo);
      };
    }
  }, [children]);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      // Calculate the width of a single item based on the container's clientWidth
      // This makes it more responsive to different screen sizes
      const itemWidth = Math.max(container.clientWidth * 0.8, 280); // At least 280px or 80% of container width
      
      container.scrollBy({
        left: direction === 'left' ? -itemWidth : itemWidth,
        behavior: 'smooth'
      });
    }
  };

  const scrollToDot = (index) => {
    const container = scrollContainerRef.current;
    if (container) {
      // Calculate the width of a single item based on the container's clientWidth
      const itemWidth = Math.max(container.clientWidth * 0.8, 280); // At least 280px or 80% of container width
      
      container.scrollTo({
        left: index * itemWidth,
        behavior: 'smooth'
      });
    }
  };

  const numberOfDots = Math.ceil(totalWidth / visibleWidth);

  return (
    <div className="scroll-wrapper" style={style}>
      {/* Left Arrow */}
      {showLeftArrow && isDesktop && (
        <button
          onClick={() => scroll('left')}
          className="scroll-arrow left"
          aria-label="Scroll left"
        >
          ←
        </button>
      )}

      {/* Right Arrow */}
      {showRightArrow && isDesktop && (
        <button
          onClick={() => scroll('right')}
          className="scroll-arrow right"
          aria-label="Scroll right"
        >
          →
        </button>
      )}

      {/* Scrollable Container */}
      <div
        ref={scrollContainerRef}
        className="scroll-container"
      >
        {children}
      </div>

      {/* Navigation Dots */}
{/*       {numberOfDots > 1 && (
        <div className="scroll-dots">
          {[...Array(numberOfDots)]?.map((_, index) => (
            <button
              key={index}
              onClick={() => scrollToDot(index)}
              className={`scroll-dot ${index === activeDot ? 'active' : ''}`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default ScrollDiv;
